<template>
  <div class="company">
    <div class="company-hd b-box">
      <top-ad :topAdList="topAdList"></top-ad>
      <div style="text-align: center; padding: 30px 0 10px 0">
        <div class="company-hd-content1">名企真题</div>
        <div class="company-hd-content2">对标往届成绩线，距离一目了然。（<a href='/ojques.html?id=64568738ea2ce53399dcc626'>一键开启IDE练习</a>）</div>
      </div>
      <div class="company-type">
        <company-cell
          v-for="(item, index) in homeCompList"
          :key="index"
          :item="item"
        />
      </div>
    </div>
    <div class="down company-hd w-box">
      <div class="company-bd">
        <middle-ad :middleAdList="middleAdList"></middle-ad>
      </div>
      <div class="company-ft">
        <div style="text-align: center; padding: 10px 0">
          <div class="company-hd-content1">在线编程</div>
          <div class="company-hd-content2">
            工欲善其事必先利其器，阿里、京东、360等都使用的OJ系统。（<a href='/ojques.html?id=64568738ea2ce53399dcc626'>一键开启IDE练习</a>）
          </div>
        </div>
        <code-icon-cell
          v-for="(item, index) in cptTopicTypeList"
          :key="index"
          :item="item"
        />
      </div>
    </div>
    <div class="bottom-img">
      <el-button type="primary" @click="onCalender"> 查看日历</el-button>
    </div>
  </div>
</template>
<script>
import CompanyCell from '@/components/practice/company/company-cell'
import CodeIconCell from '@/components/practice/company/code-icon-cell'
import PicCell from '@/components/practice/company/pic-cell'
import TopAd from '@/components/practice/ad/top'
import MiddleAd from '@/components/practice/ad/middle'
import { LOGIN_API } from "@/api.js";
import { companyImgs, companyBdData, topicTypeList } from './config'
export default {
  data() {
    return {
      homeCompList: [],
      topAdList: [],
      middleAdList: [],

      cptTopicTypeList: [],
    }
  },
  components: {
    CompanyCell,
    PicCell,
    CodeIconCell,
    TopAd,
    MiddleAd,
  },
  mounted() {
    this.getHomeCompList()
    this.loadAdConfig()
    this.initCodeProgram()
    window.scrollTo(0, 0)
  },
  methods: {
    loadAdConfig() {
      let post = {
        category: 8,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              let list = res.data.result[0].data
              this.topAdList = list.filter((item) => item.position == 1)
              this.middleAdList = list.filter((item) => item.position == 2)
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    getHomeCompList() {
      this.$axios
        .get(`${LOGIN_API}/customer/api/homeCompList`)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              let list = res.data.result
              list.map((item) => {
                item.compName = item.compName.replace('2', '')
                this.homeCompList.push(item)
              })
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    initCodeProgram() {
      this.cptTopicTypeList = topicTypeList
      this.$axios
        .get(`${LOGIN_API}/customer/api/paperList`)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              let data = res.data.result
              this.cptTopicTypeList.map((item) => {
                data.map((dd) => {
                  if (dd.title == item.title) {
                    item.num = dd.basePractiseCount
                    item.ques = dd.questionCount
                  }
                })
              })
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    onCalender() {
      this.$router.push({ path: '/calendar' })
    },
  },
  computed: {
    cptCompanyImgs() {
      return companyImgs
    },
    cptCompanyBdData() {
      return companyBdData
    },
  },
}
</script>
<style lang="scss" scoped>
.company {
  color: #666;
  .company-hd {
    font-weight: 300;
    .company-hd-content1 {
      padding: 10px;
      font-size: 34px;
    }
    .company-hd-content2 {
      font-size: 12px;
      padding: 10px 0;
    }
    .company-type {
      width: 1100px;
      margin: auto;
    }
  }

  .down {
    background-color: #fff;
    padding: 20px;
    .company-bd {
      width: 1080px;
      margin: auto;
    }
  }
  .company-ft {
    width: 1100px;
    margin: auto;
  }
  .bottom-img {
    width: 100%;
    height: 230px;
    margin-bottom: -4px;
    background: url('~@/static/images/com-cand.png') no-repeat center bottom;
    text-align: center;
    .el-button {
      margin-top: 150px;
      padding: 12px 28px;
      background-color: #29bdb9;
      border: 0;
      color: #fff;
      border-radius: 2px;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.b-box {
  background: #f7f8fd url('~@/static/images/bbg.png') repeat-x;
}
.w-box {
  background: #fff url('~@/static/images/wbg.png') repeat-x;
}
</style>


// WEBPACK FOOTER //
// src/pages/practice/company/index.vue